import FAQCategory from "../components/FAQ/FAQCategory";

const FAQ = () => {
  const faqData = [
    {
      title: "PEDIDOS Y COMPRAS",
      subcategories: [
        {
          title: "Compras",
          items: [
            {
              question:
                "¿Puedo comprar con ustedes sin tener acceso a la plataforma?",
              answer: `Nuestras ventas se realizan unicamente a través de nuestra plataforma en línea, la cual requiere registro previo para acceder a nuestros precios. Te recomendamos registrarte en nuestra plataforma a través de este formulario para aprovechar todas las ventajas exclusivas de Omova Carbon Fiber.`,
            },
            {
              question: "¿Cómo hago un pedido?",
              answer: `Regístrate completando este formulario.
            Recibe tu acceso y explora nuestro catálogo.
            Selecciona los productos y realiza tu pedido.
            Envía el comprobante de pago por WhatsApp o súbelo a la plataforma.
            Confirmamos y enviamos tu pedido una vez verificada la transferencia.`,
            },
            {
              question:
                "¿Puedo modificar o cancelar mi pedido después de haberlo realizado?",
              answer: `Sí, contáctanos lo antes posible a través de contacto@omova.com.mx o por WhatsApp. Intentaremos atender tu solicitud antes de que el pedido sea procesado y enviado.`,
            },
            {
              question: "¿Cómo obtengo una factura de mi compra?",
              answer: `Solicita la factura durante el proceso de compra. Será cargada en la orden de compra de la plataforma una vez confirmado el pago. Para ayuda adicional, contáctanos a través de nuestros canales de atención al cliente.`,
            },
            {
              question: "¿Ofrecen descuentos para compras al por mayor?",
              answer: `Sí, ofrecemos descuentos para compras al por mayor. Los precios se ajustan en función del volumen y la frecuencia de tus pedidos, y después de registrarte, los precios que encontrarás en nuestra plataforma ya estarán personalizados para tu perfil de cliente. Para obtener más detalles no dudes en contactarnos.`,
            },
            {
              question:
                "¿Cómo puedo obtener descuentos o promociones especiales?",
              answer: `Ofrecemos precios personalizados y promociones basadas en el volumen y la frecuencia de compra. En caso de tener algún descuento o promoción, te lo informaremos a través de tus datos de contacto registrados.`,
            },
          ],
        },
        {
          title: "Pagos",
          items: [
            {
              question: "¿Qué métodos de pago aceptan?",
              answer:
                "Aceptamos pagos mediante transferencia electrónica de fondos o depósitos a nuestras cuentas.",
            },
            {
              question: "¿Qué sigue después de pagar?",
              answer:
                "Sube el comprobante de pago a la plataforma o envíalo por WhatsApp. Confirma el pago por WhatsApp para que podamos procesar tu orden. Es importante que nos confirmes por WhatsApp que has realizado el pago, para que podamos darle seguimiento y convertirlo en una orden.",
            },
            {
              question: "¿Sus métodos de pago son seguros?",
              answer:
                "Sí, todos nuestros métodos de pago son seguros. Utilizamos protocolos de seguridad avanzados para proteger tus datos y asegurar que todas las transacciones se realicen de manera confiable y segura.",
            },
            {
              question: "¿Ofrecen opciones de pago a plazos?",
              answer:
                "No, los pagos deben hacerse en una sola exhibición. Asegúrate de realizar el pago rápidamente para procesar tu pedido sin demoras.",
            },
          ],
        },
        {
          title: "Envíos",
          items: [
            {
              question: "¿Realizan envíos a todo México?",
              answer:
                "Sí, en Omova Carbon Fiber realizamos envíos a todo México.",
            },
            {
              question: "¿Realizan envíos internacionales?",
              answer:
                "Por el momento, no realizamos envíos fuera de México ni envíos internacionales.",
            },
            {
              question: "¿Puedo rastrear mi pedido?",
              answer:
                "Sí, te proporcionaremos un número de rastreo a través de WhatsApp una vez que tu pedido sea enviado. Todos los envíos de fibra de carbono se pueden rastrear, pero no todas las paqueterías ofrecen rastreo para envíos de resina.",
            },
            {
              question: "¿Cuánto cuesta el envío?",
              answer:
                "El costo de envío varía según la ubicación de tu domicilio. Sin embargo, ofrecemos un descuento del 2% del valor de tu pedido en el costo del envío. Una vez realizada la orden, nos comunicaremos contigo en caso de que haya una diferencia por pagar respecto al envío.",
            },
            {
              question: "¿Cuánto tiempo tarda la preparación de mi pedido?",
              answer:
                "Si recibimos el pago antes de la 1:00 pm, trataremos de enviar tu pedido el mismo día. El tiempo de preparación puede variar según la cantidad de pedidos pendientes.",
            },
          ],
        },
        {
          title: "Devoluciones, Reembolsos y Cambios",
          items: [
            {
              question: "¿Puedo cambiar un producto por otro?",
              answer:
                "No ofrecemos cambios directos. Debes devolver el producto y luego hacer una nueva compra, siempre que el producto sea apto para devolución. Consulta nuestra política de devolución para más información.",
            },
            {
              question: "¿Cuál es su política de devoluciones?",
              answer:
                "Puedes devolver un producto dentro de los 30 días posteriores a la entrega. La devolución debe ser comunicada a contacto@omova.com.mx. El cliente asume el costo de envío y el producto debe estar en su estado original. No aceptamos devoluciones de fibra de carbono tejida, pero sí de resina, flakes, catalizador, y fibra forjada o diamond. Revisa nuestra política de devolución o contáctanos para más detalles.",
            },
            {
              question: "¿Cómo solicito un reembolso?",
              answer:
                "Comunica tu devolución a contacto@omova.com.mx. El reembolso se procesará en 48 a 72 horas hábiles desde la confirmación y se efectuará con el mismo método de pago. Consulta nuestra política de devolución para más información.",
            },
            {
              question: "¿Cuánto tiempo tarda el proceso de reembolso?",
              answer:
                "El reembolso se procesa en 48 a 72 horas hábiles. Durante temporadas altas, los tiempos pueden ser más largos. Consulta nuestra política de devolución para más información.",
            },
          ],
        },
        {
          title: "Garantías",
          items: [
            {
              question: "¿Qué tipo de garantía ofrecen en sus productos?",
              answer:
                "Garantizamos la calidad de todos nuestros productos, incluyendo fibra de carbono y resinas, cumpliendo con las normas de calidad y especificaciones anunciadas.",
            },
            {
              question: "¿Qué cubre la garantía?",
              answer:
                "Cubre la calidad, características y condiciones del producto. Si hay alteraciones o usos indebidos, analizaremos la situación para asegurar que recibas el producto en condiciones adecuadas.",
            },
            {
              question: "¿Cómo puedo hacer válida mi garantía?",
              answer:
                "Contáctanos a través de nuestros canales de atención al cliente. Nuestro equipo te guiará en el proceso para validar tu garantía.",
            },
            {
              question: "¿Cuánto tiempo dura la garantía?",
              answer:
                "La garantía dura 30 días desde la recepción del producto. Durante este periodo, puedes devolverlo si no cumple con las características y condiciones anunciadas. Consulta nuestra política de devolución para más detalles.",
            },
          ],
        },
      ],
    },
    {
      title: "PRODUCTOS Y PLATAFORMA",
      subcategories: [
        {
          title: "Productos",
          items: [
            {
              question: "¿Qué tipos de productos ofrecen?",
              answer:
                "Ofrecemos tejidos de fibra de carbono, resinas, catalizadores, resina negra o gel coat y productos complementarios para tus proyectos. Explora nuestra categoría de productos para más detalles.",
            },
            {
              question:
                "¿Cómo elijo el tipo de fibra de carbono adecuado para mi proyecto?",
              answer:
                "La elección depende de las necesidades específicas de tu proyecto. Consulta nuestro catálogo y contacta a nuestro equipo para recibir asesoramiento personalizado en la sección de contacto.",
            },
            {
              question: "¿Ofrecen muestras de sus productos?",
              answer:
                "Sí, ofrecemos un muestrario gratuito con 7 llaveros hechos con diferentes tejidos. Completa nuestro formulario y, si cumples con los criterios, recibirás el muestrario para evaluar la calidad de nuestros productos.",
            },
            {
              question:
                "¿Cuáles son las especificaciones técnicas de sus productos?",
              answer:
                "Nuestras especificaciones técnicas incluyen detalles sobre el tejido, densidad, peso y patrón de entrelazado. Encuentra esta información en nuestro catálogo en línea o contáctanos para más detalles.",
            },
            {
              question: "¿Puedo convertirme en distribuidor de sus productos?",
              answer:
                "Sí, puedes convertirte en distribuidor de nuestros productos. Nuestra plataforma está diseñada para pedidos al por mayor y buscamos socios que puedan ayudar a expandir la disponibilidad de nuestros productos.",
            },
            {
              question: "¿Cuáles son los requisitos para ser distribuidor?",
              answer:
                "Para convertirte en distribuidor, necesitamos evaluar ciertos criterios específicos. Puedes comenzar completando nuestro formulario de registro.",
            },
            {
              question: "¿Ofrecen colaboraciones con talleres o empresas?",
              answer:
                "Sí, ofrecemos colaboraciones con talleres o empresas ya sea para alguna campaña, activación o evento. Si estás interesado en realizar una colaboración, contáctanos a través de contacto@omova.com.mx para discutir los detalles.",
            },
          ],
        },
        {
          title: "Plataforma",
          items: [
            {
              question: "¿Cómo creo una cuenta en su plataforma?",
              answer:
                "Completa el formulario de registro en nuestra página web. Una vez que envíes el formulario, recibirás acceso a nuestra plataforma si cumples con los criterios establecidos.",
            },
            {
              question: "¿Cómo funciona la plataforma?",
              answer:
                "Después de registrarte y recibir acceso, podrás explorar el catálogo, realizar pedidos, enviar comprobantes de pago y ver precios exclusivos. Confirmaremos tu pedido y lo enviaremos tras la verificación. Te proporcionaremos una guía para aprovechar al máximo nuestras funcionalidades.",
            },
            {
              question:
                "¿Por qué necesito llenar un formulario para registrarme?",
              answer:
                "El formulario nos permite verificar que cumples con nuestros criterios, asegurando que nuestros productos lleguen a quienes los necesitan y mejorando nuestro servicio y soporte.",
            },
            {
              question: "¿Cómo recupero mi contraseña?",
              answer:
                "Si olvidas tu contraseña, comunícate con nosotros a través de la sección de contacto, para restablecer tu acceso a nuestra plataforma.",
            },
            {
              question: "¿Puedo ver mi historial de pedidos u órdenes?",
              answer:
                "Sí, puedes ver tu historial de pedidos y cotizaciones en la sección correspondiente de tu cuenta.",
            },
            {
              question: "¿Cómo actualizo mi información de contacto?",
              answer:
                "Puedes actualizar tu información de contacto accediendo a la sección de 'Perfil' en nuestra plataforma. Aquí podrás modificar tus datos y guardar los cambios.",
            },
          ],
        },
      ],
    },
    {
      title: "SEGURIDAD",
      subcategories: [
        {
          title: "Soporte Técnico",
          items: [
            {
              question: "¿Cómo contacto al servicio de atención al cliente?",
              answer:
                "Envíanos un correo a contacto@omova.com.mx o contáctanos por WhatsApp desde el número en nuestra página web. Estamos aquí para ayudarte.",
            },
            {
              question:
                "¿Ofrecen asistencia técnica para el uso de sus productos?",
              answer:
                "Te ayudamos con dudas sobre qué producto necesitas, pero no ofrecemos asesoría sobre fabricación, reparación o aplicación de fibra de carbono.",
            },
            {
              question: "¿Tienen algún tutorial o guía de uso?",
              answer:
                "Sí, tenemos guías de uso y tutoriales disponibles para ayudarte a utilizar nuestra plataforma de manera adecuada. Estos recursos están disponibles en la sección para ti.",
            },
          ],
        },
        {
          title: "Privacidad y Seguridad",
          items: [
            {
              question: "¿Cómo protegen mi información personal?",
              answer:
                "Usamos protocolos de seguridad avanzados y encriptación para proteger tu información personal, y seguimos políticas estrictas de privacidad.",
            },
            {
              question: "¿Puedo eliminar mi cuenta?",
              answer:
                "Sí, contacta a contacto@omova.com.mx para solicitar la eliminación de tu cuenta y datos asociados.",
            },
            {
              question: "¿Cómo utilizan mi información personal?",
              answer:
                "Tu información se usa para procesar pedidos, ofrecer acceso a la plataforma, brindarte asistencia, y mejorar nuestros servicios. También puede usarse para enviarte información relevante.",
            },
            {
              question: "¿Comparten mi información con terceros?",
              answer:
                "No compartimos tu información personal con terceros, excepto para completar transacciones con procesadores de pagos o servicios de envío.",
            },
            {
              question:
                "¿Puedo optar por no recibir comunicaciones de marketing?",
              answer:
                "Sí, puedes optar por no recibir comunicaciones de marketing. Contacta a contacto@omova.com.mx para solicitar cambiar o cancelar suscripción a este tipo de comunicación.",
            },
          ],
        },
      ],
    },
  ];

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-start bg-cover bg-center py-8"
      style={{ backgroundImage: "url('/images/fondoNegro.webp')" }}
    >
      <div className="w-full max-w-6xl rounded-lg p-6">
        <h1 className="font-extrabold text-5xl md:text-6xl mb-8 text-center">
          PREGUNTAS FRECUENTES
        </h1>

        {faqData.map((category, idx) => (
          <div key={idx} className="max-w-2xl mx-auto">
            <FAQCategory category={category} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
